import { Deserializable } from '../_common/deserializable';

export class User implements Deserializable {
    id: number;
    username: string;
    role: string;
    roleName: string;
    createdAt: string;
    token?: string;
    status: number;
    msg: string;

    deserialize(input: any): this {
      return Object.assign(this, input);
    }
}
